import React, { useState, useRef } from "react";

import { withStyles, useTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import {
  Popover,
  Typography,
  List,
  ListItem,
  useMediaQuery,
  Grid,
} from "@material-ui/core";
import classNames from "classnames";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import concat from "lodash/concat";
import orderBy from "lodash/orderBy";
import flatten from "lodash/flatten";
import slice from "lodash/slice";
import isEmpty from "lodash/isEmpty";

// context
import { useHomeInfo } from "../../useGlobal";

// styles
import useStyles from "./styles";

const LinkTabs = withStyles(theme => ({
  root: {
    borderBottom: "1px solid #e8e8e8",
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
}))(Tabs);

const LinkTab = withStyles(theme => ({
  root: {
    ...theme.typography.h5,
    textTransform: "none",
    minWidth: 115,
    marginRight: theme.spacing(1.75),
    color: theme.palette.common.grey[900],
    "&:hover": {
      color: theme.palette.common.black,
      opacity: 1,
    },
    "&$selected": {
      color: theme.palette.common.black,
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: theme.palette.common.black,
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: 70,
    },
  },
  selected: {},
}))(Tab);

export default function MovieMenu (props) {
  const classes = useStyles();
  const theme = useTheme();

  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isScrollButton = isSm ? "off" : "on";

  const { menus = {} } = useHomeInfo();
  const { children = [] } = menus;
  const maxChildrenMenus = 8;
  const childrenMenus = slice(
    orderBy(
      flatten(children.map(e => (menus[e]?.in_menu ? menus[e].pages : []))),
    ),
    0,
    maxChildrenMenus,
  );
  const mixedMenus = concat(
    { name: "所有分類" },
    { name: "所有影片", href: "/video/list" },
    childrenMenus,
  );
  const menuLinks = mixedMenus.map(e => e.href);
  const pathIndex = menuLinks.indexOf(window.location.pathname);
  const activeTabIndex = pathIndex === -1 ? false : pathIndex;
  const allCatLink = window.location.pathname;

  const [value, setValue] = useState(activeTabIndex);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openedPopover, setOpenedPopover] = useState(false);
  const popoverAnchor = useRef(null);

  const popoverEnter = ({ currentTarget }) => {
    setOpenedPopover(true);
  };

  const popoverLeave = ({ currentTarget }) => {
    setOpenedPopover(false);
  };

  const open = Boolean(anchorEl);

  const MenuGroup = props => {
    const { item, isPartner } = props;
    return (
      <Grid container>
        <Grid item>
          <List disablePadding>
            <ListItem disableGutters>
              <Typography
                variant='subtitle2'
                color='primary'
                className={classNames({
                  [classes.menuGroupTitle]: !isPartner,
                  [classes.partnerMenuGroupTitle]: isPartner,
                })}
              >
                {item.groupTitle}
              </Typography>
            </ListItem>
            {item.pages.slice(0, 5).map((page, i) => (
              <ListItem
                disableGutters
                key={i}
                className={classes.menuGroupItem}
              >
                <Typography
                  variant='caption'
                  component={"a"}
                  href={page.href}
                  className={classNames(classes.navLink, "submenu-item", {
                    [classes.menuGroupTitle]: !isPartner,
                    [classes.partnerMenuGroupTitle]: isPartner,
                  })}
                  onClick={handleClose}
                >
                  {page.name}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Grid>
        {!isEmpty(item.pages.slice(5, 10)) && (
          <Grid item>
            <List disablePadding>
              <ListItem disableGutters className={classes.hidden}>
                <div>dummy</div>
              </ListItem>
              {item.pages.slice(5, 10).map((page, i) => (
                <ListItem
                  disableGutters
                  key={i}
                  className={classes.menuGroupItem}
                >
                  <Typography
                    variant='caption'
                    component={"a"}
                    href={page.href}
                    className={classNames(classes.navLink, "submenu-item", {
                      [classes.menuGroupTitle]: !isPartner,
                      [classes.partnerMenuGroupTitle]: isPartner,
                    })}
                    onClick={handleClose}
                  >
                    {page.name}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Grid>
        )}
      </Grid>
    );
  };

  const renderMenuTab = (menu, idx) => {
    if (menu.name === "所有分類") {
      return (
        <LinkTab
          ref={popoverAnchor}
          key={`tab${idx}`}
          className={classes.tab}
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup='true'
          label={menu.name}
          component={Link}
          to={allCatLink}
          onMouseEnter={popoverEnter}
          onMouseLeave={popoverLeave}
        />
      );
    }

    if (menu.href && menu.href.indexOf("http") !== -1) {
      return (
        <LinkTab
          key={`tab${idx}`}
          className={classes.tab}
          label={menu.name}
          component={"a"}
          href={menu.href}
          target='_blank'
        />
      );
    }

    return (
      <LinkTab
        key={`tab${idx}`}
        className={classes.tab}
        label={menu.name}
        component={Link}
        to={menu.href}
      />
    );
  };

  const AllPages = () => {
    const { tags, topics, partners } = menus;
    return (
      <div className={classes.menu}>
        {tags && !isEmpty(tags.pages) && (
          <div className={classes.menuItem}>
            <MenuGroup item={tags} />
          </div>
        )}

        {topics && !isEmpty(topics.pages) && (
          <div className={classes.menuItem}>
            <MenuGroup item={topics} />
          </div>
        )}

        {partners && !isEmpty(partners.pages) && (
          <div className={classes.menuItem}>
            <MenuGroup item={partners} isPartner />
          </div>
        )}
      </div>
    );
  };
  return (
    <div>
      <div className={classes.root}>
        <div>
          <LinkTabs
            value={activeTabIndex}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons={isScrollButton}
          >
            {mixedMenus.map((menu, idx) => renderMenuTab(menu, idx))}
          </LinkTabs>
          <Popover
            elevation={0}
            id='mouse-over-popover'
            className={classes.popover}
            classes={{ paper: classes.popoverContent }}
            open={openedPopover}
            anchorEl={popoverAnchor.current}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            onClose={handleClose}
            disableRestoreFocus
            PaperProps={{
              onMouseEnter: popoverEnter,
              onMouseLeave: popoverLeave,
            }}
          >
            <div>{<AllPages />}</div>
          </Popover>
        </div>
      </div>
    </div>
  );
}
